var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenfavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80891 13.1578C5.21393 12.1701 3.73148 11.0113 2.38789 9.70201C1.43828 8.75323 0.715368 7.60215 0.273169 6.33471C-0.515247 3.8663 0.405809 1.04422 2.99948 0.211589C3.67148 -0.00412576 4.38538 -0.0558582 5.08146 0.0607949C5.77753 0.177448 6.43554 0.459076 7.0005 0.882092C7.56462 0.460256 8.22136 0.179317 8.91603 0.0626837C9.61071 -0.0539498 10.3232 -0.00288121 10.9941 0.211589C13.5878 1.04422 14.5162 3.89577 13.7278 6.33471C13.2877 7.60315 12.5645 8.75468 11.6131 9.70201C10.2695 11.0113 8.78707 12.1701 7.19208 13.1578L7.01525 13.261L6.80891 13.1578Z",
    fill: "#097E52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74146 2.98914C10.1268 3.11261 10.4666 3.34824 10.7173 3.66589C10.968 3.98354 11.1182 4.36876 11.1488 4.77227",
    fill: "#097E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74146 2.98914C10.1268 3.11261 10.4666 3.34824 10.7173 3.66589C10.968 3.98354 11.1182 4.36876 11.1488 4.77227",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenfavIcon);
export default __webpack_public_path__ + "static/media/greenfavIcon.e48536c17b5f366c49146be553c05895.svg";
export { ForwardRef as ReactComponent };